// import { api } from '../../config';


function getBasicInfo() {
	const { appId, organizationId, namespaceId, organization = {} } = window.$$context;
	const { communityId } = organization;
	const { userInfo = {} } = JSON.parse(window.localStorage.getItem('basic_info') || '{}');
	const { id: operatorUid } = userInfo;

	return {
		communityId,
		organizationId,
		appId,
		operatorUid,
		namespaceId
	};
}

function handelcommunityScope (data = {}, allPrivileges, onlyIds = false) {
	let operations = [];
	if (data.allOperationFlag === 1) {
		allPrivileges.forEach((el) => {
			if (onlyIds) {
				operations = [].concat(operations, el.operations.map(o => o.id));
			} else {
				operations = [].concat(operations, el.operations);
			}
		});
	} else {
		const { assignedOperations = [] } = data;
		assignedOperations.forEach(element => {
			if (onlyIds) {
				operations = [].concat(operations, element.operations.map(o => o.id));
			} else {
				operations = [].concat(operations, element.operations);
			}
		});
	}
	return operations;
}

function filterProject (allProject = [], projecIds = []) {
	console.log(projecIds);
	const projects = projecIds.map(id => {
		let projectItem;
		allProject.some(item => {
			console.log(id, item.projectId, id === item.projectId);
			if (id === item.projectId) {
				projectItem = { ...item };
				return true;
			}
			return false;
		});
		return projectItem;
	});
	return projects;
}

export {
	getBasicInfo,
	handelcommunityScope,
	filterProject
};
